/* Swiper
**************************************************************/
var swiperMetamorphosis = null;
var init = false;
var navigation = window.SwiperNavigation;

function swiperMode() {
    // Get the number of slides
    const slides = document.querySelectorAll('.item--metamorphosis');
    const slideCount = slides.length;

    // Get navigation elements to show/hide as needed
    const nextNav = document.querySelector('.metamorphosis__posts-nav-next');
    const prevNav = document.querySelector('.metamorphosis__posts-nav-prev');

    // Check if we have enough slides to enable swiper
    const shouldEnableSwiper = window.innerWidth >= 992 ? slideCount > 3 :
        window.innerWidth >= 768 ? slideCount > 2 :
            slideCount > 1;

    // Show/hide navigation based on whether swiper should be enabled
    if (nextNav && prevNav) {
        if (shouldEnableSwiper) {
            nextNav.style.display = '';
            prevNav.style.display = '';
        } else {
            nextNav.style.display = 'none';
            prevNav.style.display = 'none';
        }
    }

    // If we should disable swiper but it's already initialized
    if (!shouldEnableSwiper && swiperMetamorphosis) {
        // Destroy the existing swiper instance
        swiperMetamorphosis.destroy(true, true);
        swiperMetamorphosis = null;
        init = false;
        return;
    }

    // If we should enable swiper and it's not initialized yet
    if (shouldEnableSwiper && !init) {
        init = true;

        // init Swiper:
        swiperMetamorphosis = new Swiper('.js-metamorphosis__posts', {
            // configure Swiper to use modules
            modules: [SwiperNavigation],
            loop: slideCount > 3, // Only enable loop if we have enough slides
            slidesPerView: 1,
            spaceBetween: 18,
            slideClass: "item--metamorphosis",
            setWrapperSize: "74.6875rem;",
            navigation: {
                nextEl: '.metamorphosis__posts-nav-next',
                prevEl: '.metamorphosis__posts-nav-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is <=768px
                0: {
                    slidesPerView: 1,
                },
                // when window width is >= 769px
                768: {
                    slidesPerView: 2,
                },
                // when window width is >= 992px
                992: {
                    slidesPerView: 3,
                }
            }
        });

    }
        const posts_container = document.querySelector('.js-metamorphosis__posts');
        posts_container.classList.add('loaded');
}

/* On Load
**************************************************************/
window.addEventListener('load', function() {
    swiperMode();
});

/* On Resize
**************************************************************/
window.addEventListener('resize', function() {
    swiperMode();
});